"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openNewWindow = void 0;
var openNewWindow = function (url, width, height) {
    if (width === void 0) { width = 0; }
    if (height === void 0) { height = 0; }
    var left = (window.screen.width - width) / 2, top = (window.screen.height - height) / 2;
    var win = window.open(url, '_blank', "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=".concat(width, ", height=").concat(height, ", top=").concat(top, ", left=").concat(left));
    if (win) {
        if (win.moveTo) {
            win.moveTo(left, top);
        }
        win.focus();
    }
};
exports.openNewWindow = openNewWindow;
//# sourceMappingURL=open-new-window.js.map